import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/supplierIntegration'
import Component from 'components/SupplierIntegration'

export default createListViewContainer({ actions, selectors: selectors.supplierIntegration })(Component)
